import { createFileRoute } from '@tanstack/react-router'

import { RenewMembershipPage } from '@/features/membership/renewal'

export const Route = createFileRoute('/_authenticated/membership/renew')({
  component: RenewMembershipPage,
})

